import { BaseReportTableComponent } from '@/src/app/features/reports/components/base-report-table/base-report-table.component';
import { CompactPatientDataModule } from '@/src/app/features/reports/components/compact-patient-data/compact-patient-data.module';
import { CompactPatientHeaderModule } from '@/src/app/features/reports/components/compact-patient-header/compact-patient-header.module';
import { PatientLinkComponentModule } from '@/src/app/features/reports/components/patient-link/patient-link.component';
import { SurgicalTreatmentCompactReportRecord } from '@/src/app/features/reports/features/surgical-treatments-compact-report/surgical-treatments-compact-report.model';
import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';
import { ReadonlyCommonsModule } from '@/src/app/shared/modules/readonly-commons/readonly-commons.module';
import { CommonModule } from '@angular/common';
import { Component, Input, NgModule, OnDestroy, OnInit } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule, MatTable, MatColumnDef, MatCellDef, MatCell, MatRowDef, MatRow } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormModule } from '@shared/components/form/form.module';
import { CompactPatientHeaderComponent } from '../../../components/compact-patient-header/compact-patient-header.component';
import { CompactPatientDataComponent } from '../../../components/compact-patient-data/compact-patient-data.component';
import { InlineReadonlyFieldComponent } from '@shared/modules/readonly-commons/components/inline-readonly-field/inline-readonly-field.component';
import { ValueSeparatorComponent } from '@shared/modules/general-commons/components/value-separator/value-separator.component';
import { ImageThumbnailComponent } from '@shared/components/image-thumbnail/image-thumbnail.component';
import { EmptyTableStateComponent } from '@shared/components/empty-table-state/empty-table-state.component';
import { AgeYearMonthPipe } from '@shared/modules/readonly-commons/pipes/age-year-month/age-year-month.pipe';
import { UnitPipe } from '@shared/modules/readonly-commons/pipes/unit/unit.pipe';
import { LocalNamePipe } from '@shared/pipes/local-name.pipe';
import { ReportType } from '@src/app/features/reports/components/report-filters/models/report-filters.model';

@Component({
  selector: 'stx-surgical-treatment-compact-report-table',
  templateUrl: './surgical-treatment-compact-report-table.component.html',
  styleUrls: ['./surgical-treatment-compact-report-table.component.scss'],
  imports: [
    MatPaginator,
    MatTable,
    MatColumnDef,
    MatCellDef,
    MatCell,
    CompactPatientHeaderComponent,
    CompactPatientDataComponent,
    InlineReadonlyFieldComponent,
    ValueSeparatorComponent,
    ImageThumbnailComponent,
    MatRowDef,
    MatRow,
    EmptyTableStateComponent,
    TranslateModule,
    AgeYearMonthPipe,
    UnitPipe,
    LocalNamePipe
  ]
})
export class SurgicalTreatmentCompactReportTableComponent
  extends BaseReportTableComponent<SurgicalTreatmentCompactReportRecord>
  implements OnInit, OnDestroy
{
  readonly reportType: ReportType = 'SURGICAL_TREATMENTS_COMPACT';

  @Input() deIdentified = false;
  @Input() showPagination: boolean;
  displayedColumns: string[] = ['patient'];

  constructor() {
    super();
  }

  ngOnInit(): void {
    super.onInit();
  }

  ngOnDestroy(): void {
    super.onDestroy();
  }
}

@NgModule({
  imports: [
    MatTableModule,
    MatSortModule,
    TranslateModule,
    CommonModule,
    MatIconModule,
    RouterModule,
    MatPaginatorModule,
    PatientLinkComponentModule,
    MatDividerModule,
    FormModule,
    CompactPatientDataModule,
    ReadonlyCommonsModule,
    GeneralCommonsModule,
    CompactPatientHeaderModule,
    SurgicalTreatmentCompactReportTableComponent
  ],
  exports: [SurgicalTreatmentCompactReportTableComponent]
})
export class SurgicalTreatmentCompactReportTableComponentModule {}
